import HardwareDetails from './newHardwareDetail';

export const IndexHardwareDetails = (props: any) => {
  return <HardwareDetails {...props} />;
};
